import { Package } from '../../packages/package'
import { PackageNodeGroup } from './storage-manager-packages.component'
import { StoragePath } from '../../storage-path'
import { Quantity } from '@elderbyte/ngx-starter'

export class PackageGroupRow {
  constructor(
    public packageNodeGroup: PackageNodeGroup,
    public item: Package,
    public children?: PackageGroupRow[],
    public isChild?: boolean
  ) {}

  public get hasChildren(): boolean {
    return !!this.children
  }

  public get storagePath(): StoragePath {
    return this.packageNodeGroup.storagePath
  }

  public get isUnassigned(): boolean {
    return this.packageNodeGroup.storagePath.isEmpty
  }

  public get package(): Package {
    return this.item
  }

  public get packageNumber(): string {
    return this.package.number
  }

  public get packageWeight(): Quantity {
    return this.hasChildren ? null : this.item.weight
  }
}
